import React, {useEffect, useRef, useContext} from 'react'
import {entitiesAllFields} from '../../graphql/barcode/queries/entitiesAllFieldsQuery'
import {MenuItem, Select} from '@material-ui/core'
import {Query} from 'react-apollo'
import BarcodeLabelTextToolbar from '../BarcodeLabelTextToolbar'
import useStyles from './BarcodeLabelFieldSelect.styles'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'

function BarcodeLabelFieldSelect(props) {
  const {state} = useContext(BarcodeLabelEditorContext)
  const {item} = props
  const classes = useStyles(props)
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const [fields, setFields] = React.useState(props.item.fields || [])
  const [value, setValue] = React.useState(props.item.field_id || '')
  const refSelect = useRef()

  function handleChange(event) {
    setValue(event.target.value)
    props.onChange({...item, ...{field_id: event.target.value}})
  }
  function setFieldsData(data) {
    if (props.item.field_id) {
      let dataFields = data.entitiesAllFields.fields
      Object.keys(dataFields).forEach(value => {
        let currentField = dataFields[value].find(
          obj => parseInt(obj.id) === parseInt(props.item.field_id)
        )
        if (currentField) {
          setFields(dataFields[value])
          setValue(currentField.id)
        }
      })
    }
  }

  useEffect(() => {
    refSelect.current.focus()
  }, [])

  const handleChangeToolbar = (k, v) => {
    if (k === 'font_size') {
      v *= state.zoom
    }
    props.onChange({...item, [k]: v, focused: true})
  }

  return (
    <React.Fragment>
      <BarcodeLabelTextToolbar
        values={{...item, font_size: item.font_size / state.zoom}}
        show={item.focused}
        onChange={handleChangeToolbar}
      />
      <Select
        id={`input_${item.key}`}
        ref={refSelect}
        component="input"
        style={{
          fontSize: `${item.font_size}px`,
          fontFamily: item.font_family,
          textDecoration: item.text_decoration,
          fontStyle: item.font_style,
          fontWeight: item.font_weight,
          color: `#${item.color}`,
          textAlign: item.text_align,
        }}
        className={classes.select}
        value={value}
        onChange={handleChange}
      >
        {fields.map(option => (
          <MenuItem key={option.id} value={option.id} onBlur={e => e.stopPropagation()}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
      <Query
        query={entitiesAllFields}
        variables={{
          accountId: parseInt(userSettings.id),
          token: userSettings.token,
        }}
        onCompleted={data => setFieldsData(data)}
        fetchPolicy="network-only"
      >
        {({loading, error, data}) => {
          return null
        }}
      </Query>
    </React.Fragment>
  )
}

export default BarcodeLabelFieldSelect
